import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/material';
import {amber, blue, blueGrey, green, grey, orange, red} from '@mui/material/colors';
import Typography from '@mui/material/Typography';

const getColorByStatusCategory = (statusCategory) => {
    switch (statusCategory) {
        case 'Applied':
            return blue[500];
        case 'Offered':
            return orange[500];
        case 'Accepted':
            return green[500];
        case 'Admitted':
            return amber[500];
        case 'Rejected':
            return red[500];
        case 'Reserved':
            return blueGrey[500];
        case 'Withdrawl':
            return blueGrey[500];
        case 'Enquiry':
            return blue.A400;
        // Maria, 19 October 2026: a child on roll in a blue-green, and an admitted applicant (on roll from a date still
        // to come) in the blue of the Save buttons
        case 'OnRoll':
            return '#1E8FA0';
        case 'AdmittedApplicant':
            return '#1976d2';
        default:
            return grey[500];
    }
};

// Maria, 19 October 2026: a fine line round the photo in the colour of the badge. It is drawn over the edge of the photo,
// so the photo keeps its size.
export const photoLineSx = colour => ({outline: `1px solid ${colour}`, outlineOffset: '-1px'});
export const statusPhotoLineSx = statusCategory => photoLineSx(getColorByStatusCategory(statusCategory));
export const statusColour = getColorByStatusCategory;

// Maria, 19 October 2026: a child on roll has an 'On Roll' badge, and a child whose date of admission is still to come
// an 'Admitted' badge (the 'Admitted Applicants' filter)
export const onRollStatus = dateOfAdmission => (dateOfAdmission && new Date(dateOfAdmission) > new Date()
    ? {status: 'Admitted', statusCategory: 'AdmittedApplicant'}
    : {status: 'On Roll', statusCategory: 'OnRoll'});

const Div = styled('div')(({color}) => ({
    backgroundColor: color,
    color: grey[50],
    fontWeight: 600,
    textAlign: 'center'
}));

// Maria, 20 October 2026: every badge on a profile card the same, with 12 pixel text and no side padding, so 'Member of
// Staff' fits inside the green. On a card narrower than any today the text shrinks just enough to fit, on every badge alike.
export const BADGE_SX = {px: 0, py: 0.125, containerType: 'inline-size'};
export const BADGE_TEXT_SX = {fontSize: 'min(12px, 13.4cqi)', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center'};

const ProfileStatus = ({status, statusCategory, isStudentProfile}) => {
    const color = getColorByStatusCategory(statusCategory);

    return (!isStudentProfile
            ? <Div
                sx={{
                    // Maria, 19 October 2026: smaller, on the smaller profile cards
                    width: '56px',
                    ...BADGE_SX,
                    borderRadius: 3
                }}
                color={color}
            >
                <Typography
                    noWrap
                    title={status}
                    sx={BADGE_TEXT_SX}
                    variant="subtitle2">{status}</Typography>
            </Div>
            : <Div
                color={color}
                sx={{
                    paddingLeft: 2,
                    paddingRight: 2,
                    paddingTop: 1,
                    paddingBottom: 1,
                    borderRadius: 5
                }}
            >
                <Typography variant="body1">{status}</Typography>
            </Div>
    );
};

ProfileStatus.defaultProps = {
    isStudentProfile: false
};

ProfileStatus.propTypes = {
    status: PropTypes.string,
    statusCategory: PropTypes.string,
    isStudentProfile: PropTypes.bool.isRequired
};
export default ProfileStatus;